interface Props {
  color?: string;
}

export const DoubleTickIcon: React.FC<Props> = ({ color }) => {
  return (
    <svg className="w-full h-full" viewBox="0 0 12 7" fill="none">
      <path
        d="M2.968 7a.498.498 0 01-.214-.047.594.594 0 01-.186-.14L.157 4.171A.635.635 0 010 3.726c0-.182.052-.33.157-.445a.517.517 0 01.4-.172c.161 0 .294.058.399.172L2.982 5.5l.8.875-.415.438a.594.594 0 01-.185.14.498.498 0 01-.214.047zm3.225-.016a.578.578 0 01-.214-.039.495.495 0 01-.186-.133L3.367 4.156a.635.635 0 01-.157-.445c0-.182.053-.33.157-.445a.517.517 0 01.4-.172c.162 0 .295.057.4.172l2.026 2.218L11.044.172a.517.517 0 01.4-.172c.161 0 .294.057.399.172A.634.634 0 0112 .617a.635.635 0 01-.157.446l-5.25 5.75a.495.495 0 01-.186.132.578.578 0 01-.214.04zm0-3.265l-.814-.875L7.805.188a.525.525 0 01.406-.172c.167 0 .303.057.407.171.105.115.157.26.157.438a.624.624 0 01-.157.438L6.193 3.719z"
        fill={color ? color : "#fff"}
      />
    </svg>
  );
};

export default DoubleTickIcon;
